import { render } from "./PageFooter.vue?vue&type=template&id=4c958aaa"
import script from "./PageFooter.vue?vue&type=script&lang=js"
export * from "./PageFooter.vue?vue&type=script&lang=js"
script.render = render

export default script